import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedDataService } from '@teem/services/shared-data.service';
import { ImportProductModalComponent } from '@teem/product-module/modals/import-product-modal/import-product-modal.component';
import { ImportServiceModalComponent } from '@teem/service-module/modals/import-service-modal/import-service-modal.component';

@Component({
  selector: 'store-welcome',
  templateUrl: './store-welcome.component.html',
  styleUrls: ['./store-welcome.component.scss']
})
export class StoreWelcomeComponent implements OnInit {
  @Input() type: string;
  @Output() onAddClick: EventEmitter<any> = new EventEmitter();
  hasStore: boolean = false;
  userInfo: any;

  constructor(
    private sharedDataService: SharedDataService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.hasStore = data.userInfo.has_store
        this.userInfo = data.userInfo
      }
    })
  }

  openImportModal() {
    if (this.userInfo?.store_type == 'service') {
      const modalRef = this.modalService.open(ImportServiceModalComponent);
      modalRef.result.then(result => {
        window.location.reload();
      })
    } else {
      const modalRef = this.modalService.open(ImportProductModalComponent);
      modalRef.result.then(result => {
        window.location.reload();
      })
    }
  }

}
